import { LikeBySpeakerServerData, LikeByUserServerData } from '@typings/like';

export const likesFormatter = (
  likes: {
    byUser: LikeByUserServerData[];
    bySpeaker: LikeBySpeakerServerData[];
  } = { byUser: [], bySpeaker: [] },
) => {
  const likesByUser = likes.byUser.reduce(
    (
      acc: Record<string, { count: number; isLiked?: boolean }>,
      { userId, count, isLiked }: LikeByUserServerData,
    ) => {
      acc[userId] = {
        count: Number(count),
        isLiked: !!isLiked,
      };

      return acc;
    },
    {},
  );
  const likesBySpeaker = likes.bySpeaker.reduce(
    (
      acc: Record<string, { count: number; isLiked?: boolean }>,
      { speakerId, count, isLiked }: LikeBySpeakerServerData,
    ) => {
      acc[speakerId] = {
        count: Number(count),
        isLiked: !!isLiked,
      };

      return acc;
    },
    {},
  );

  return {
    likesByUser,
    likesBySpeaker,
  };
};
